import React, { useRef } from 'react';

export const FileInput = ({ onFilesSelected }) => {
  const fileInputRef = useRef(null);

  // Handle changes when files are selected via the input
  const handleFileChange = (event) => {
    // Convert FileList object to a standard Array and pass to parent
    onFilesSelected(Array.from(event.target.files));
    // Clear the input value so the same file can be selected again if needed
    event.target.value = null;
  };

  return (
    <div
      className="p-8 border-4 border-dashed border-gray-300 rounded-xl text-center cursor-pointer hover:border-blue-500 hover:bg-blue-50 transition-all duration-300 ease-in-out group"
      onClick={() => fileInputRef.current.click()} // Trigger hidden input click when div is clicked
    >
      <input
        type="file"
        multiple // Allow multiple file selection
        accept="audio/*,video/*" // Filter for audio and video files
        onChange={handleFileChange}
        ref={fileInputRef} // Ref to access the input element
        className="hidden" // Hide the default file input
      />
      <div className="flex flex-col items-center justify-center">
        <svg
          className="w-16 h-16 text-gray-400 group-hover:text-blue-600 transition-colors duration-300"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M7 16a4 4 0 01-.88-7.903A5 5 0 0115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
          ></path>
        </svg>
        <p className="text-lg font-semibold text-gray-700 group-hover:text-blue-800 mt-4">
          Drag & drop audio/video files here
        </p>
        <p className="text-gray-500 group-hover:text-blue-600 mt-2">
          or <span className="text-blue-500 font-bold">click to browse</span>
        </p>
        <p className="text-xs text-gray-400 mt-1">(Supports .mp3, .wav, .mp4, etc.)</p>
      </div>
    </div>
  );
}